<template>
  <div class="grid gap-20 mr-auto py-20 pl-10 text-left">
    <div>
      <sCheckbox
        v-model="testpProps.disabled">
        disabled
      </sCheckbox>
      <sCheckbox
        v-model="testpProps.inline">
        inline
      </sCheckbox>
      <sCheckbox
        v-model="testpProps.editable">
        editable
      </sCheckbox>
    </div>


    <CollapseBlock
      :value.sync="show.dateRangeDialogWithType">
      <div
        slot="title">
        DateRangeDialogWithType
      </div>

      <div>
        <div class="align-center flex gap-5">
          <sCheckbox
            v-model="testpProps.showPeriods">
            showPeriods
          </sCheckbox>
          <sSelect
            placeholder="componentType"
            :value.sync="testpProps.componentType">
            <sOption value="date">
              date
            </sOption>
            <sOption value="month">
              month
            </sOption>
            <sOption value="year">
              year
            </sOption>
            <sOption value="datetime">
              datetime
            </sOption>
            <sOption value="time">
              time
            </sOption>
            <sOption value="week">
              week
            </sOption>
          </sSelect>
        </div>
        <div class="row-test px-5 py-5">
          <div>DateRangeDialog </div>
          <DateRangeDialogWithType
            :component-type="testpProps.componentType"
            data-qa="filter-bar-date-range"
            :disabled="testpProps.disabled"
            :search.sync="dateArray"
            :show-periods="testpProps.showPeriods"
            :value-type="'date'"/>
          <div>{{ dateArray }} {{ typeof dateArray[0] }} {{ typeof dateArray[1] }}</div>
        </div>
        <div class="row-test px-5 py-5">
          <div>DateRangeDialog DD/MM/YYYY</div>
          <DateRangeDialogWithType
            :component-type="testpProps.componentType"
            data-qa="filter-bar-date-range"
            :disabled="testpProps.disabled"
            :search.sync="dateArray2"
            :show-periods="testpProps.showPeriods"
            :value-type="'DD/MM/YYYY'"/>
          <div>{{ dateArray2 }} {{ typeof dateArray2[0] }} {{ typeof dateArray2[1] }}</div>
        </div>
        <div class="row-test px-5 py-5">
          <div>DateRangeDialog YYYY-MM-DDTH:mm:ssZ</div>
          <DateRangeDialogWithType
            :component-type="testpProps.componentType"
            data-qa="filter-bar-date-range"
            :disabled="testpProps.disabled"
            :search.sync="dateArray3"
            :show-periods="testpProps.showPeriods"
            :value-type="'YYYY-MM-DDTH:mm:ssZ'"/>
          <div>{{ dateArray3 }} {{ typeof dateArray3[0] }} {{ typeof dateArray3[1] }}</div>
        </div>
      </div>
    </CollapseBlock>


    <CollapseBlock
      :value.sync="show.basic">
      <div
        slot="title">
        Basic
      </div>
      <div class="grid gap-20 mr-auto pt-2">
        <div class="row-test">
          <div>date (default)</div>
          <sDatePicker
            v-model="value1"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            format="YYYY-MM-DD"
            :inline="testpProps.inline"
            placeholder="Оберіть дату"
            type="date"/>
          <div>{{ value1 }}</div>
        </div>
        <div class="row-test">
          <div>month</div>
          <sDatePicker
            v-model="value2"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            placeholder="Оберіть місяць"
            type="month"/>
          <div>{{ value2 }}</div>
        </div>
        <div class="row-test">
          <div>year</div>
          <sDatePicker
            v-model="value3"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            placeholder="Оберіть рік"
            type="year"/>
          <div>{{ value3 }}</div>
        </div>
        <div class="row-test">
          <div>datetime</div>
          <sDatePicker
            v-model="value4"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            placeholder="Оберіть датуtime"
            type="datetime"/>
          <div>{{ value4 }}</div>
        </div>
        <div class="row-test">
          <div>time</div>
          <sDatePicker
            v-model="value5"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            placeholder="Оберіть час"
            type="time"/>
          <div>{{ value5 }}</div>
        </div>
        <div class="row-test">
          <div>week</div>
          <sDatePicker
            v-model="value6"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            placeholder="Оберіть тиждень"
            type="week"/>
          <div>{{ value6 }}</div>
        </div>
      </div>
    </CollapseBlock>
    <CollapseBlock
      :value.sync="show.valueType">
      <div
        slot="title">
        ValueType
      </div>
      <div class="grid gap-20 mr-auto pt-2">
        <div class="row-test">
          <p>format</p>
          <sDatePicker
            v-model="value8"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            format="YYYY-MM-DD"
            :inline="testpProps.inline"
            value-type="format"/>
          <p>
            <code>{{ typeof value8 }} = {{ value8 }}</code>
          </p>
        </div>
        <div class="row-test">
          <p>date (Date Object)</p>
          <sDatePicker
            v-model="value7"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            value-type="date"/>
          <p>
            <code>{{ typeof value7 }} = {{ value7 }}</code>
          </p>
        </div>
        <div class="row-test">
          <p>timestamp</p>
          <sDatePicker
            v-model="value9"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            value-type="timestamp"/>
          <p>
            <code>{{ typeof value9 }} = {{ value9 }}</code>
          </p>
        </div>
        <div class="row-test">
          <p>DD/MM/YYYY</p>
          <sDatePicker
            v-model="value10"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            format="YYYY-MM-DD"
            :inline="testpProps.inline"
            value-type="DD/MM/YYYY"/>
          <p>
            <code>{{ typeof value10 }} = {{ value10 }}</code>
          </p>
        </div>
      </div>
    </CollapseBlock>
    <CollapseBlock
      :value.sync="show.range">
      <div
        slot="title">
        Range
      </div>
      <div class="grid gap-20 mr-auto pt-2">
        Support to select a date range.
        <div class="row-test">
          <p>
            date range
          </p>
          <sDatePicker
            v-model="value20"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            placeholder="Оберіть дату range"
            range
            type="date"/>
          <div>{{ value20 }}</div>
        </div>
        <div class="row-test">
          <p>
            datetime range
          </p>
          <sDatePicker
            v-model="value21"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            placeholder="Оберіть датуtime range"
            range
            type="datetime"/>
          <div>{{ value21 }}</div>
        </div>
      </div>
    </CollapseBlock>
    <CollapseBlock
      :value.sync="show.disabled">
      <div
        slot="title">
        DisabledDate & DisabledTime
      </div>
      <div class="grid gap-20 mr-auto pt-2">
        Disabled part of dates and time by disabledDate and disabledTime respectively.

        You should let the defaultValue not be disabled, when you use disabledDate or disabledTime.
        <div class="row-test">
          <p>
            Not before than today and not after than a week
          </p>
          <sDatePicker
            v-model="value14"
            :default-value="new Date()"
            :disabled="testpProps.disabled"
            :disabled-date="disabledBeforeTodayAndAfterAWeek"
            :editable="testpProps.editable"
            :inline="testpProps.inline"/>
          <div>{{ value14 }}</div>
        </div>
        <div class="row-test">
          <p>
            Not before 09:00
          </p>
          <sDatePicker
            v-model="value15"
            :default-value="new Date().setHours(9, 0, 0, 0)"
            :disabled="testpProps.disabled"
            :disabled-time="notBeforeNineOClock"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            placeholder="HH:mm:ss"
            type="time"
            value-type="format"/>
          <div>{{ value15 }}</div>
        </div>
        <div class="row-test">
          <p>
            Not before than 12:00 Today
          </p>
          <sDatePicker
            v-model="value16"
            :default-value="new Date().setHours(12, 0, 0, 0)"
            :disabled="testpProps.disabled"
            :disabled-date="notBeforeToday"
            :disabled-time="notBeforeTodayTwelveOClock"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            type="datetime"
            value-type="format"/>
          <div>{{ value16 }}</div>
        </div>
      </div>
    </CollapseBlock>
    <CollapseBlock
      :value.sync="show.shortcut">
      <div
        slot="title">
        Shortcut
      </div>
      <div class="grid gap-20 mr-auto pt-2">
        You can set shortcuts to improve user experience.
        Use the header slot or the footer slot to render extra element in panel for customized requirements.
        <div class="row-test">
          <p>
            shortcuts
          </p>
          <sDatePicker
            v-model="value17"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            placeholder="Оберіть дату"
            :shortcuts="shortcuts"/>
          <div>{{ value17 }}</div>
        </div>
        <div class="row-test">
          <p>
            header slot
          </p>
          <sDatePicker
            v-model="value18"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            placeholder="Оберіть дату">
            <template v-slot:header="{ emit }">
              <sButton
                small
                type="text"
                @click="emit(new Date())">
                Today
              </sButton>
            </template>
          </sDatePicker>
          <div>{{ value18 }}</div>
        </div>
        <div class="row-test">
          <p>
            footer slot
          </p>
          <sDatePicker
            v-model="value19"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            placeholder="Оберіть дату range"
            range>
            <template v-slot:footer="{ emit }">
              <div style="text-align: left">
                <sButton
                  small
                  type="text"
                  @click="selectNextThreeDay(emit)">
                  NextThreeDay
                </sButton>
              </div>
            </template>
          </sDatePicker>
          <div>{{ value19 }}</div>
        </div>
        <div class="row-test">
          <p>
            rangeShortcuts
          </p>
          <sDatePicker
            v-model="value19"
            confirm
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            :inline="testpProps.inline"
            placeholder="Оберіть дату range"
            range
            :shortcuts="rangeShortcuts"/>
          <div>{{ value19 }}</div>
        </div>
      </div>
    </CollapseBlock>
    <CollapseBlock
      :value.sync="show.timeFormat">
      <div
        slot="title">
        Hide seconds selection & display AMPM selection
      </div>
      <div class="grid gap-20 mr-auto pt-2">
        <div class="row-test">
          <p>
            The columns of the time Picker is displayed according to the value of format(HH:mm:ss) by default.
            You can also set showHour showMinute showSecond to override the default value
          </p>
          <sDatePicker
            v-model="value11"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            format="hh:mm a"
            :inline="testpProps.inline"
            placeholder="hh:mm a"
            type="time"
            value-type="format"/>
          <div>{{ value11 }}</div>
        </div>
      </div>
    </CollapseBlock>
    <CollapseBlock
      :value.sync="show.interval">
      <div
        slot="title">
        Interval and custom time options
      </div>
      <div class="grid gap-20 mr-auto pt-2">
        <div class="row-test">
          <p>
            Set stepped time options by hourStep minuteStep secondStep
            Set custom time options by hourOptions minuteOptions secondOptions.
          </p>
          <sDatePicker
            v-model="value12"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            format="HH:mm"
            :hour-options="hours"
            :inline="testpProps.inline"
            :minute-step="30"
            placeholder="HH:mm"
            type="time"
            value-type="format"/>
          <div>{{ value12 }} {{ hours }}</div>
        </div>
      </div>
    </CollapseBlock>
    <CollapseBlock
      :value.sync="show.fixedTimeList">
      <div
        slot="title">
        Select fixed time list
      </div>
      <div class="grid gap-20 mr-auto pt-2">
        <div class="row-test">
          <p>
            You can provide a list of fixed time for users to choose by timePickerOptions
          </p>
          <sDatePicker
            v-model="value13"
            :disabled="testpProps.disabled"
            :editable="testpProps.editable"
            format="hh:mm a"
            :inline="testpProps.inline"
            placeholder="hh:mm a"
            :time-picker-options="{
              start: '08:30',
              step: '00:30',
              end: '18:30',
            }"
            type="time"/>
          <div>{{ value13 }}</div>
        </div>
      </div>
    </CollapseBlock>
  </div>
</template>
<script>
import DateRangeDialogWithType from 'components/common/dialogs/DateRangeDialogWithType.vue'

import CollapseBlock from 'components/common/CollapseBlock.vue'

export default {
  name: 'testDate',
  data() {
    return {
      show: {
        dateRangeDialogWithType: true,
        basic: false,
        valueType: false,
        range: false,
        disabled: false,
        shortcut: false,
        timeFormat: false,
        interval: false,
        fixedTimeList: false,
      },
      testpProps: {
        disabled: false,
        showPeriods: true,
        componentType: 'date',
        inline: false,
        editable: true,
      },

      calendar: new Date(),
      value1: null,
      value2: null,
      value3: null,
      value4: null,
      value5: null,
      value6: null,

      value7: new Date(2019, 9, 9),
      value8: '2019-10-09',
      value9: new Date(2019, 9, 9).getTime(),
      value10: '09/10/2019',

      value11: null,
      value12: null,

      value13: null,

      value14: new Date(),
      value15: null,
      value16: null,

      value17: null,
      value18: null,
      value19: null,

      value20: null,
      value21: null,

      hours: Array.from({ length: 10 }).map((_, i) => i + 8),
      rangeShortcuts: [
        {
          text: 'Today',
          onClick() {
            const date = new Date()
            return [date, date]
          },
        },
        {
          text: 'Next Three Day',
          onClick() {
            const start = new Date()
            const end = new Date()
            end.setTime(end.getTime() + 3 * 24 * 3600 * 1000)
            const date = [start, end]
            return date
          },
        },
      ],

      shortcuts: [
        {
          text: 'Today',
          onClick() {
            const date = new Date()
            // return a Date
            return date
          },
        },
        {
          text: 'Yesterday',
          onClick() {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            return date
          },
        },
      ],

      dateArray: [null, new Date()],
      dateArray2: ['01/03/2026', '31/03/2026'],
      dateArray3: ['2026-03-01T00:00:00+02:00', '2026-03-31T23:59:59+03:00'],
    }
  },
  methods: {
    disabledBeforeTodayAndAfterAWeek(date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)

      return date < today || date > new Date(today.getTime() + 7 * 24 * 3600 * 1000)
    },
    notBeforeNineOClock(date) {
      return date.getHours() < 9
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0))
    },
    notBeforeTodayTwelveOClock(date) {
      return date < new Date(new Date().setHours(12, 0, 0, 0))
    },
    selectNextThreeDay(emit) {
      const start = new Date()
      const end = new Date()
      end.setTime(end.getTime() + 3 * 24 * 3600 * 1000)
      const date = [start, end]
      emit(date)
    },
  },
  components: {
    CollapseBlock,
    DateRangeDialogWithType,
  }
}
</script>
<style lang="scss" scoped>
.row-test {
  display: grid;
  align-items: center;
  gap: 20px;
  text-align: left;
  background: #ebf6f5;
  grid-template-columns: 150px minmax(min-content, 300px) 1fr;
}
</style>
